/**
 * Breakpoint configuration
 */
const breakpoints = {
  sm: 320,
  md: 640,
  lg: 1024,
  xl: 1200
};

export default breakpoints;

export const thresholds = {
  min: 320,
  max: 1440
};
